module.exports = __webpack_public_path__ + "media/redioxu.c3cc6d1e.mp3";